import React from 'react';
import { MailIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../data/contact';
export function Contact() {
  return <section aria-labelledby="contact-heading" className="bg-paper-200 py-14 sm:py-20" data-id="element-66" data-mp="357dk0a5nnmqb">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-6" data-id="element-67" data-mp="317le657nbuon">
        <p className="text-[10px] font-semibold uppercase tracking-label text-brass-dark sm:text-[11px]" data-id="element-68" data-mp="2w7qkjtwhkqzw">
          Contact us
        </p>
        <h2 id="contact-heading" className="mt-4 font-display text-2xl font-semibold leading-snug text-ink sm:text-4xl" data-id="element-69" data-mp="3swg4rqvl5vp1">
          Questions before you buy?
        </h2>
        <p className="mt-4 text-sm leading-relaxed text-ink-soft sm:text-base" data-id="element-70" data-mp="3k44nauig9il7">
          Write to us and we&rsquo;ll get back to you. We answer every message about access,
          content, and refunds.
        </p>

        <a href={`mailto:${SUPPORT_EMAIL}`} className="mt-7 inline-flex max-w-full items-center gap-3 border border-brass bg-paper px-5 py-4 text-sm font-semibold text-ink transition-colors duration-150 ease-out hover:bg-brass-wash sm:text-base" data-id="element-71" data-mp="ghnkhur9eti4">
          <MailIcon className="h-5 w-5 shrink-0 text-brass" aria-hidden="true" data-id="element-72" data-mp="3otcsde12kiq4" />
          <span className="break-all" data-id="element-73" data-mp="3b42koa7e4itd">{SUPPORT_EMAIL}</span>
        </a>
      </div>
    </section>;
}